<i18n>
{
	"en": {
		"cancelLabel": "Cancel",
		"confirmLabel": "Select Vendor",
		"searchPlaceholder": "Search text",
		"title": "Search for Vendor",
		"name": "Name",
		"mail": "Mail",
		"vendorNumber": "Vendor.Nr."
	},
	"no": {
		"cancelLabel": "Avbryt",
		"confirmLabel": "Velg leverandør",
		"searchPlaceholder": "Søketekst",
		"title": "Søk etter leverandør",
		"name": "Navn",
		"mail": "Mail",
		"vendorNumber": "Lev.nr."
	}
}
</i18n>

<template>
	<t-dialog
		:icon="icon"
		:isShown="isShown"
		:title="$t('title')"
		:confirmLabel="$t('confirmLabel')"
		:cancelLabel="$t('cancelLabel')"
		:isConfirmDisabled="selectedVendor === undefined"
		iconType="bp"
		@close="onClose"
		@ok="onOk"
		@shown="onShown"
	>
		<t-form-group>
			<t-search-input v-model="searchValue" :placeholder="$t('searchPlaceholder')"/>
			<t-grid
				v-if="showGrid"
				:items="filteredItems"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="40"
				:showFilters="false"
				:singleSelect="true"
				:selectableMode="['row']"
				selectable
				style="height: 400px; width: 500px;"
				@selected="setSelectedVendor"
				@enter="onEnter"
				@rowDoubleClick="selectAndClose"
			/>
		</t-form-group>
	</t-dialog>
</template>

<script>
export default {
	props: {
		icon: String,
		isShown: Boolean,
		items: Array,
		initialSearchValue: String
	},
	data() {
		return {
			searchValue: '',
			showGrid: false,
			selectedVendor: undefined,
			defaultColumnDefinition: { resizable: true, }
		};
	},
	computed: {
		filteredItems() {
			if (!this.searchValue || this.searchValue === '') return this.items;
			return this.items.filter(item => this.filterItem(item, this.searchValue));
		},
		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('name'),
					minWidth: 150,
				},
				{
					field: 'vendorNumber',
					displayName: this.$t('vendorNumber'),
					width: 100,
				}
			];
		}
	},
	methods: {
		onShown() {
			if (this.initialSearchValue) {
				this.searchValue = this.initialSearchValue;
			}
			this.showGrid = true;
		},
		filterItem(item, searchString) {
			if (!item) return false;
			let ret = true;
			for (let c of searchString.split(' ')) {
				ret = ret &&
					( (item.name && item.name.toLowerCase().includes(c.toLowerCase()))
					|| ( item.vendorNumber && item.vendorNumber.toString().toLowerCase().includes(c.toLowerCase()) )
					|| ( item.mail && item.mail.toString().toLowerCase().includes(c.toLowerCase()) )
					);
			}
			return ret;
		},
		selectAndClose(vendorId) {
			if (!vendorId) return;
			this.selectedVendor = this.items.find( x => x.id === vendorId);
			this.onOk();
			this.onClose();
		},
		onEnter() {
			if (!this.selectedVendor) return;
			this.onOk();
			this.onClose();
		},
		setSelectedVendor(vendorIds) {
			if (!vendorIds) return;
			let vendor = this.items.find(x => x.id === vendorIds[0]);
			this.selectedVendor = vendor;
		},
		onClose() {
			this.$emit('close');
			this.selectedVendor = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
		onOk() {
			this.$emit('ok', this.selectedVendor);
			this.selectedVendor = undefined;
			this.searchValue = '';
			this.showGrid = false;
		},
	},
};
</script>

<style>

</style>
